import { Link } from '@mui/material'

const NeedHelp = () => {
  return (
    <Link href="https://resources.meshify.com/defender-slim/" rel="noopener noreferrer" target="_blank" underline="hover">
      Need Help?
    </Link>
  )
}

export default NeedHelp
